export function formatPhoneNumber(value: string | undefined): string {
  if (value == '' || value == null || value == undefined) {
    return ''
  }

  const cleaned = ('' + value).replace(/\D/g, '')
  let match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4]
  }
  match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return value
}
